import { useState } from "react";
import { ShortSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsShortProps = {
    settings: ShortSettings
    onChange: (settings: ShortSettings) => void;
}

export const AppCustomPropertySettingsShort = ({settings, onChange} : AppCustomPropertySettingsShortProps) => {
    return (
        <div className="app-custom-property-settings-container">

            <div className="app-custom-property-group">

                <div className="app-custom-property-label">
                    Max Chars
                </div>
                <div className="app-custom-property-value">
                    <MySwitch
                        checked={settings.maxCharsOn}
                        onChange={(checked: boolean) => {
                            onChange({
                                ...settings,
                                maxCharsOn: checked
                            });
                        }}
                    />
                </div>
            </div>

            {settings.maxCharsOn &&
                <div className="app-custom-property-group">
                    <div className="app-custom-property-label">
                        Max Chars   
                    </div>
                    <div className="app-custom-property-value">
                        <input 
                            type="number"
                            value={settings.maxChars}
                            onChange={(event) => {
                                onChange({
                                    ...settings,
                                    maxChars: parseInt(event.target.value)
                                });
                            }}
                        />
                    </div>
                </div>
            }
        </div>
    )
}